import { marketingService } from '@/api';
import {
	AdsInfoProps,
	CampaignChannels,
	ChannelAd,
	ChannelAdDetails,
	ChannelsAdsData,
	ImagePayload,
} from '@/interfaces';
import { urlToFile } from './urlToFile';
import { addWaterMark } from './addWaterMark';
import { awsService } from '@/api/aws';

export const handleUpdateCopy = async (
	campaignId: string,
	adsInfoCurrent: AdsInfoProps
): Promise<void> => {
	const env = process.env.NEXT_PUBLIC_SERVER;
	const isDevelop = env === 'develop';

	const channelsData: ChannelAd[] = [];

	if (
		!adsInfoCurrent.callToAction.trim() ||
		!adsInfoCurrent.headline.trim() ||
		!adsInfoCurrent.description.trim()
		// ||!adsInfoCurrent.magicLinkText?.trim() // TO-DO: uncomment when this will be approved
	)
		return;

	const channelAdData: ChannelAdDetails = {
		id: adsInfoCurrent.adId,
		cta: adsInfoCurrent.callToAction || '',
		headline_1: adsInfoCurrent.headline,
		description_1: adsInfoCurrent.description.replace(/<\/?p>/g, ''), // remove <p> tags added by the editor (the post were being created with that tag)
		// magic_link_text: adsInfoCurrent.magicLinkText, // TO-DO: uncomment when this will be approved
	};

	// TO-DO: remove isDevelop validation when this will be approved
	if (isDevelop) {
		channelAdData.magic_link_text = adsInfoCurrent.magicLinkText || '';
	}

	if (adsInfoCurrent.type === 'GOOGLE_SEARCH') {
		channelAdData.headline_2 = adsInfoCurrent.headline2 || '';
		channelAdData.headline_3 = adsInfoCurrent.headline3 || '';
		channelAdData.description_2 =
			adsInfoCurrent.description2?.replace(/<\/?p>/g, '') || '';
	}

	channelsData.push({
		channel: adsInfoCurrent.type,
		ads: [channelAdData],
	});

	const newData: ChannelsAdsData = {
		channelAds: channelsData,
	};

	await marketingService.patchUploadCopies(campaignId, newData);
};

export const handleAddWatermarkImages = async (
	campaignId: string,
	adsInfoCurrent: AdsInfoProps
) => {
	try {
		const newImage = await handleMarkImage(
			adsInfoCurrent.images,
			adsInfoCurrent.type
		);
		const imagePayload: ImagePayload[] = [
			{
				aspectRatio: 0,
				url: newImage,
				channel: adsInfoCurrent?.type,
				is_image_user: true,
			},
		];
		saveImage(imagePayload, campaignId);
	} catch (error) {
		console.log('error watermark');
	}
};

const handleMarkImage = async (url: string, channel: CampaignChannels) => {
	let newUrl = url;
	const file = await urlToFile(url);
	if (file) {
		const watermarkImage = await addWaterMark(file, channel);
		const response = await awsService.uploadImage(watermarkImage);
		newUrl = response.data.data.location;
	}

	return newUrl;
};

const saveImage = async (
	imagesUpdated: ImagePayload[],
	id: string
): Promise<void> => {
	try {
		await marketingService.patchUploadImagesToCampaign(id, {
			images: imagesUpdated,
		});
	} catch (error) {
		console.error(error);
	}
};
